import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  CamGroupCarouselView,
  VideoPlayer,
  CommentsView,
  InfoPanelView,
  NewsletterView,
} from '../../components';
import { panelWidgets } from '../../constants/widgets';
import { setCurrentItemDirectly } from '../../actions/currentItem';
import Loader from '../../components/Loader';
import DisqusView from '../../components/Comments/Disqus';

class LivecamPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      admin: false,
    };
  }
  componentWillMount() {
    const { routeParams: { mediaobject: livecamSlug}, setLivecam } = this.props;
    setLivecam(livecamSlug).then(() => {
      this.setState({ loaded: true, admin: true });
    }).catch((err) => {
      this.setState({ loaded: true, admin: false });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId !== this.props.userId) {
      const { routeParams: { mediaobject: livecamSlug}, setLivecam } = this.props;
      this.setState({
        loaded: false,
        admin: false,
      });
      setLivecam(livecamSlug).then(() => {
        this.setState({ loaded: true, admin: true });
      }).catch((err) => {
        this.setState({ loaded: true, admin: false });
      });
    }
  }

  shouldRenderPanel(type) {
    if (type === 'weather' && !this.props.weatherEnabled) {
      return false;
    }
    return true;
  }

  render() {
    const { commentsFullWidth, slug, disqusId, initialDataLoaded, newCommentSystem } = this.props;
    const { loaded, admin } = this.state;
    const rightColClass = commentsFullWidth ? 'col-12' : 'col-12 col-md-6';
    const CommentsComponent = newCommentSystem ? CommentsView : DisqusView;

    if (!initialDataLoaded) {
      return (
        <div className="livecams transition-item">
          <div className="container-fluid content">
            <div className="row">
              <div className="col-sm-12">
                <div className="bg-fff-50 video-player container-rounded mb-20" style={{ minHeight: 400 }}>
                  <Loader dark fill />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    if (!loaded || !admin) {
      const content = (!loaded) ? <Loader dark fill /> : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 400,
          }}
        >
          <h3>You need to be logged in and have permission to preview livecams</h3>
        </div>
      );
      return (
        <div className="livecams transition-item">
          <CamGroupCarouselView />
          <div className="container-fluid content">
            <div className="row">
              <div className="col-sm-12">
                <div className="bg-fff-50 video-player container-rounded mb-20" style={{ minHeight: 400 }}>
                  { content }
                </div>
              </div>
            </div>
          </div>
          {
            !commentsFullWidth &&
            <div className="container-boxShadow mt-20 rounded-0 bg-fff-50">
              <NewsletterView />
            </div>
          }
          <div className="container-fluid content my-20">
            <div className="bg-fff-50 video-player container-rounded">
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="livecams transition-item">
        <CamGroupCarouselView />
        <div className="container-fluid content">
          <div className="row">
            <div className="col-sm-12">
              <div className="preview-notification container-rounded mb-1">Live Camera page preview (Draft)</div>
              <VideoPlayer />
            </div>
          </div>

          <div className="row info-panels">
            {!commentsFullWidth &&
            <div className="col-12 col-md-6 pr-10" id="left-column">
              <div className="dynamic-height-column">
                {panelWidgets.map((type) => {
                  return this.shouldRenderPanel(type) ? <InfoPanelView type={type} key={type} /> : null;
                })}
              </div>
            </div>
            }
            <div className={`${rightColClass} mb-2`} id="right-column">
              <div id="disqus-drag" className="disqus-comments bg-fff-75 container-rounded">
                <CommentsComponent ref="comments" slug={disqusId || slug} />
              </div>
            </div>
          </div>
        </div>
        {
          !commentsFullWidth &&
          <div className="container-boxShadow mt-20 rounded-0 bg-fff-50">
            <NewsletterView />
          </div>
        }
        <div className="container-fluid content my-20">
          <div className="bg-fff-50 video-player container-rounded">
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let backgroundImage = (!state.currentItem.data.is_offline && state.currentItem.data.snapshot)
    ? state.currentItem.data.snapshot : state.currentItem.data.thumbnail_large_url;

  backgroundImage = backgroundImage.replace('http://files', 'https://files');

  const { commentsFullWidth } = state.uiPreferences;

  return {
    backgroundImage,
    commentsFullWidth,
    slug: state.currentItem.data.slug,
    disqusId: state.currentItem.data.disqus_id,
    weatherEnabled: state.currentItem.data.weather_enabled,
    userId: state.auth.userId,
    initialDataLoaded: state.globalConfig.initialDataLoaded,
    newCommentSystem: state.currentItem.data.newCommentSystem,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLivecam: (data) => {
      return dispatch(setCurrentItemDirectly(data));
    },
  };
};

LivecamPreview.propTypes = {
  slug: PropTypes.string.isRequired,
  disqusId: PropTypes.string.isRequired,
  weatherEnabled: PropTypes.bool.isRequired,
  commentsFullWidth: PropTypes.bool.isRequired,
};

LivecamPreview.defaultProps = {
  disqusId: '',
  slug: '',
  weatherEnabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(LivecamPreview);
